export const StatusPillRenderer = (props: any) => {
  function getPrimeBgColor(
    status: string | undefined,
    colField: string,
    isFinal?: number,
  ): string {
    // Use Prime order style background colors
    if (colField === "settled" && isFinal === 1) {
      return "bg-bg-helper-green-dark";
    }

    if (!status) return "bg-bg-button-secondary";

    const statusLower = status.toLowerCase();

    switch (statusLower) {
      case "completed":
      case "settled":
      case "over payment":
      case "under payment":
        return "bg-bg-helper-green-dark";
      case "pending":
        return "bg-bg-status-yellow";
      case "expired":
      case "cancelled":
        return "bg-bg-helper-red-dark";
      default:
        return "bg-bg-status-yellow";
    }
  }

  const { data, colDef } = props;

  if (colDef?.field === "compliancePending") {
    const raw = data?.compliancePending;
    const isClear = raw !== undefined && raw !== null && Number(raw) === 0;
    const pending = raw === undefined || raw === null ? "—" : Number(raw);
    return (
      <div className="flex items-center justify-center h-full">
        <div
          className={`rounded-[6px] w-[25px] h-[18px] p-[4px] text-[10px] text-text-base flex items-center justify-center ${
            isClear ? "bg-bg-helper-green-dark" : "bg-bg-status-yellow"
          }`}
          title={
            isClear
              ? "No compliance pending"
              : typeof pending === "number"
                ? `Compliance pending: ${pending}`
                : "Compliance status unknown"
          }
        />
      </div>
    );
  }

  const status = data.status;
  let matchAgainst = "";

  switch (colDef.field) {
    case "pending":
      matchAgainst = "pending";
      break;
    case "overPayment":
      matchAgainst = "over payment";
      break;
    case "underPayment":
      matchAgainst = "under payment";
      break;
    case "expired":
      matchAgainst = "expired";
      break;
    case "cancelled":
      matchAgainst = "cancelled";
      break;
    case "paid":
    case "settled":
      matchAgainst = "completed";
      break;
    default:
      return null;
  }

  if (colDef.field === "settled" && data.isFinal === 1) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="rounded-[6px] w-[25px] h-[18px] p-[4px] text-[10px] text-text-base flex items-center justify-center bg-bg-helper-green-dark"></div>
      </div>
    );
  }

  if (status?.toLowerCase() !== matchAgainst.toLowerCase()) return null;

  const bgColor = getPrimeBgColor(status, colDef.field, data.isFinal);
  return (
    <div className="flex items-center justify-center h-full">
      <div
        className={`rounded-[6px] w-[25px] h-[18px] p-[4px] text-[10px] text-text-base flex items-center justify-center ${bgColor}`}
      ></div>
    </div>
  );
};
